import axiosInstance from "../../utils/axiosConfig";
import React, { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { FaTimesCircle } from "react-icons/fa";
import { IoMdArrowDropdown } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { MdArrowRight } from "react-icons/md";
import { TailSpin } from "react-loader-spinner";
import { API_URL } from "../../constant";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { BiErrorCircle } from "react-icons/bi";

const MercahntLogs = ({ setOpenLog, merchantDeet, setRefetch }: any) => {
  const [openButton, setOpenButton] = useState<boolean>(false);
  const [copyMail, setCopyMail] = useState<boolean>(false);
  const [showImage, setShowImage] = useState<boolean>(false);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [success, setSuccess] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [pendingloading, setPendingLoading] = useState<boolean>(false);
  const [declineloading, setDeclineloader] = useState<boolean>(false);

  const handleApprove = () => {
    if (!loading) {
      setLoading(true);
      const data = {
        status: "APPROVED", // "VERIFIED", "REJECTED", "PENDING"
        businessId: merchantDeet?._id,
      };

      // console.log(data);
      axiosInstance
        .put(`${API_URL}api/businesses/verifications`, data)
        .then((r: any) => {
          setLoading(false);
          setSuccess("Business Approved successfully");
          setRefetch((prev: number) => prev++);
          setTimeout(() => {
            setSuccess("");
            setOpenLog(false);
          }, 3000);
        })
        .catch((e: any) => {
          setError(e.response.data.message);
          setLoading(false);
          setTimeout(() => {
            setError("");
          }, 6000);
          console.log(e.response.data.message);
        });
    }
  };
  const handlePending = () => {
    if (!pendingloading) {
      setPendingLoading(true);
      const data = {
        status: "PENDING", // "VERIFIED", "REJECTED", "PENDING"
        businessId: merchantDeet?._id,
      };

      // console.log(data);
      axiosInstance
        .put(`${API_URL}api/businesses/verifications`, data)
        .then((r: any) => {
          setPendingLoading(false);
          setSuccess("Kyc set to pending successfully");
          setRefetch((prev: number) => prev++);
          setTimeout(() => {
            setSuccess("");
            setOpenLog(false);
          }, 3000);
        })
        .catch((e: any) => {
          setError(e.response.data.message);
          setPendingLoading(false);
          setTimeout(() => {
            setError("");
          }, 6000);
          console.log(e.response.data.message);
        });
    }
  };
  const handleDecline = () => {
    if (!declineloading) {
      setDeclineloader(true);
      const data = {
        status: "REJECTED", // "VERIFIED", "REJECTED", "PENDING"
        businessId: merchantDeet?._id,
      };

      // console.log(data);
      axiosInstance
        .put(`${API_URL}api/businesses/verifications`, data)
        .then((r: any) => {
          setDeclineloader(false);
          setSuccess("Business rejected successfully");
          setRefetch((prev: number) => prev++);
          setTimeout(() => {
            setSuccess("");
            setOpenLog(false);
          }, 3000);
        })
        .catch((e: any) => {
          setError(e.response.data.message);
          setDeclineloader(false);
          setTimeout(() => {
            setError("");
          }, 6000);
          console.log(e.response.data.message);
        });
    }
  };

  return (
    <div className="w-full">
      <div className="flex justify-end items-center">
        <FaTimesCircle
          onClick={() => {
            setOpenLog(false);
          }}
          className="text-[#78C2F7] text-[18px] cursor-pointer"
        />
      </div>
      <div className="flex justify-between items-center w-full mt-6">
        <div className="flex justify-start items-center gap-4">
          <div className="text-[24px] mx-auto  w-[60px] uppercase h-[60px] bg-[#032843] rounded-full text-[#0C84DA] flex justify-center items-center font-bold font-sora ">
            {merchantDeet?.name?.charAt(0)}
            {merchantDeet?.name.charAt(1)}
          </div>
          <div>
            <h4 className="font-sora text-[20px] capitalize text-[#DEE1E6] font-extrabold">
              {merchantDeet?.name}
            </h4>
            <CopyToClipboard
              text={merchantDeet?.email}
              onCopy={() => {
                setCopyMail(true);
                setTimeout(() => {
                  setCopyMail(false);
                }, 3000);
              }}
            >
              {copyMail ? (
                <h4 className="text-[12px] mt-2 xs:text-[14px] text-[#869AA9]">
                  Copied
                </h4>
              ) : (
                <h4 className="text-[#0C84DA]  text-[14px] font-medium  cursor-pointer">
                  {merchantDeet?.email}
                </h4>
              )}
            </CopyToClipboard>
          </div>
        </div>
        <div className="w-2/5 lgss:w-1/5 relative">
          <div className="flex w-full items-center justify-end">
            <button
              onClick={() => setOpenButton((prev) => !prev)}
              className="flex justify-between px-4 outline-none gap-4 h-[48px] rounded-xl w-2/3 items-center  text-[#095B97] bg-[#F7F8F9] font-medium text-[16px] "
            >
              Action
              {openButton ? (
                <MdArrowRight className="text-[24px]" />
              ) : (
                <IoMdArrowDropdown className="text-[24px]" />
              )}
            </button>
          </div>
          {openButton && (
            <div
              className={`w-full sidebar absolute bg-[#1C2227] mt-2 flex flex-col rounded-xl`}
            >
              {merchantDeet?.status === "PENDING" ? (
                <button
                  onClick={handleApprove}
                  className="w-full hover:bg-[#273037] text-white text-[16px] border-b border-gray-700 font-bold py-3 flex justify-center items-center"
                >
                  {loading ? (
                    <TailSpin color="#FFFFFF" height={30} width={30} />
                  ) : (
                    "Approve "
                  )}
                </button>
              ) : merchantDeet?.status === "APPROVED" ? (
                <button
                  onClick={handlePending}
                  className="w-full hover:bg-[#273037] text-white text-[16px] border-b border-gray-700 font-bold py-3 flex justify-center items-center"
                >
                  {pendingloading ? (
                    <TailSpin color="#FFFFFF" height={30} width={30} />
                  ) : (
                    "Pending "
                  )}
                </button>
              ) : null}

              <button
                onClick={handleDecline}
                className="text-[15px]   py-3 flex justify-center items-center  font-semibold text-[#DF4E4E]"
              >
                {declineloading ? (
                  <TailSpin color="#FFFFFF" height={30} width={30} />
                ) : (
                  "Decline "
                )}
              </button>
            </div>
          )}
        </div>
      </div>
      {success && (
        <div className="bg-green-600  w-full lgss:w-1/3 xxl:w-2/5 text-white  text-[16px] rounded-xl justify-start items-center gap-4 flex h-[60px] px-2 font-bold mt-4 mb-4">
          <AiOutlineCheckCircle className="text-3xl text-white" />
          {success}
        </div>
      )}
      {error && (
        <div className="bg-red-600 w-full lgss:w-1/3 xxl:w-2/5 text-white  text-[12px] rounded-xl justify-start items-center gap-2 flex h-[50px] px-2 font-bold mt-4">
          <BiErrorCircle className="text-xl" />
          {error}
        </div>
      )}
      <div className="w-full  bg-[#0D0D0D] p-8 mt-6">
        <h4 className="text-[#4E606E] text-[16px] ">Profile Completion</h4>
        <div className="w-full flex-col mt-8 justify-center   items-center ">
          <div className="w-full flex justify-center gap-20 items-start mt-10">
            <div className="w-full">
              <h4 className="text-[#869AA9] text-[8px] font-semibold">
                PERSONAL
              </h4>
              <div className="w-full mt-4 flex justify-between items-center">
                <h4 className="text-[#AEBCC6] text-[13px] font-semibold">
                  Email{" "}
                </h4>
                <CopyToClipboard
                  text={merchantDeet?.email}
                  onCopy={() => {
                    setCopyMail(true);
                    setTimeout(() => {
                      setCopyMail(false);
                    }, 3000);
                  }}
                >
                  {copyMail ? (
                    <span className="text-[12px] xs:text-[14px] text-[#869AA9]">
                      Copied
                    </span>
                  ) : (
                    <span className="text-[#0C84DA] font-bold text-[13px] cursor-pointer">
                      {merchantDeet?.email}
                    </span>
                  )}
                </CopyToClipboard>
              </div>
              <div className="w-full mt-4 flex justify-between items-center">
                <h4 className="text-[#AEBCC6] text-[13px] font-semibold">
                  Status
                </h4>
                <h4
                  className={
                    merchantDeet?.status === "APPROVED"
                      ? "text-[#03C668] font-bold text-[13px] cursor-pointer"
                      : merchantDeet?.status === "PENDING"
                      ? "text-[#F28A0F] font-bold text-[13px] cursor-pointer"
                      : merchantDeet?.status === "REJECTED"
                      ? "text-red-500 font-bold text-[13px] cursor-pointer"
                      : ""
                  }
                >
                  {merchantDeet?.status}
                </h4>
              </div>
              <div className="w-full mt-4 flex justify-between items-center">
                <h4 className="text-[#AEBCC6] text-[13px] font-semibold">
                  Description
                </h4>
                <h4 className="text-[#0C84DA] capitalize font-bold text-[13px] cursor-pointer">
                  {merchantDeet?.details?.description}
                </h4>
              </div>

              <div className="w-full mt-4 flex justify-between items-center">
                <h4 className="text-[#AEBCC6] text-[13px] font-bold">
                  Address
                </h4>
                <div className="text-[#0C84DA] cursor-pointer flex gap-2 justify-center items-center font-bold text-[13px] ">
                  {merchantDeet?.details?.address}
                </div>
              </div>
              <div className="w-full mt-4 flex justify-between items-center">
                <h4 className="text-[#AEBCC6] text-[13px] font-bold">
                  Business Industry
                </h4>

                <div className="text-[#0C84DA] cursor-pointer flex gap-2 justify-center items-center font-bold text-[13px] ">
                  {merchantDeet?.details?.industry}
                </div>
              </div>
              <div className="w-full mt-4 flex justify-between items-center">
                <h4 className="text-[#AEBCC6] text-[13px] font-bold">
                  Business Size
                </h4>
                <h4 className="text-[#0C84DA] font-bold text-[13px] cursor-pointer">
                  {merchantDeet?.details?.size}
                </h4>
              </div>
              <div className="w-full mt-4 flex justify-between items-center">
                <h4 className="text-[#AEBCC6] text-[13px] font-bold">
                  Business Type
                </h4>

                <h4 className="text-[#0C84DA] font-bold text-[13px] cursor-pointer">
                  {merchantDeet?.type} Business
                </h4>
              </div>
              <div className="w-full mt-4 flex justify-between items-center">
                <h4 className="text-[#AEBCC6] text-[13px] font-semibold">
                  BN Number
                </h4>
                <h4 className="text-[#0C84DA] font-bold text-[13px] cursor-pointer">
                  {merchantDeet?.bnNumber ?? "---"}
                </h4>
              </div>
              <div className="w-full mt-4 flex justify-between items-center">
                <h4 className="text-[#AEBCC6] text-[13px] font-bold">Size</h4>
                <h4 className="text-[#0C84DA] font-bold text-[13px] cursor-pointer">
                  {merchantDeet?.details?.size}
                </h4>
              </div>
            </div>
            {merchantDeet?.type === "REGISTERED" && (
              <div className="w-full">
                <h4 className="text-[#869AA9] text-[10px] font-semibold">
                  PROOF OF ADDRESS
                </h4>
                <div className="w-full mt-4 h-[140px]">
                  {merchantDeet?.documents?.proofOfAddress ? (
                    <img
                      onClick={() => {
                        setImageUrl(merchantDeet?.documents?.proofOfAddress);
                        setTimeout(() => {
                          setShowImage(true);
                        }, 300);
                      }}
                      src={merchantDeet?.documents?.proofOfAddress ?? ""}
                      className="w-full h-full object-contain rounded-xl cursor-zoom-in"
                      alt=""
                    />
                  ) : (
                    <TailSpin color="#007AFF" width={30} height={30} />
                  )}
                </div>
                <h4 className="text-[#869AA9] text-[10px] mt-6 font-semibold">
                  Identity document{" "}
                </h4>
                <div className="w-full mt-4 h-[140px]">
                  {merchantDeet?.documents?.identity ? (
                    <img
                      onClick={() => {
                        setImageUrl(merchantDeet?.documents?.identity);
                        setTimeout(() => {
                          setShowImage(true);
                        }, 300);
                      }}
                      src={merchantDeet?.documents?.identity}
                      className="w-full h-full object-contain rounded-xl cursor-zoom-in"
                      alt=""
                    />
                  ) : (
                    <TailSpin color="#007AFF" width={30} height={30} />
                  )}
                </div>
                <h4 className="text-[#869AA9] text-[10px] mt-6 font-semibold">
                  CAC document
                </h4>
                <div className="w-full mt-4 h-[140px]">
                  {merchantDeet?.documents?.cac ? (
                    <img
                      onClick={() => {
                        setImageUrl(merchantDeet?.documents?.cac);
                        setTimeout(() => {
                          setShowImage(true);
                        }, 300);
                      }}
                      src={merchantDeet?.documents?.cac ?? ""}
                      className="w-full h-full object-contain rounded-xl cursor-zoom-in"
                      alt=""
                    />
                  ) : (
                    <TailSpin color="#007AFF" width={30} height={30} />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {showImage && (
        <div className="fixed inset-0  flex font-sora justify-center items-start pt-16 pb-16 overflow-auto bg-black  bg-opacity-80">
          <div
            className={` w-11/12 mds:w-9/12     rounded-xl mx-auto p-6 bg-[#1F1F1F]  h-[650px] overflow-auto  lgss:w-[60%] xxl:w-[45%] `}
          >
            <div className="w-full flex justify-end items-center">
              <button
                onClick={() => {
                  setShowImage(false);
                }}
                className="w-[40px] h-[40px] rounded-full bg-[#007AFF] bg-opacity-10  flex justify-center items-center"
              >
                <IoClose className="text-black dark:text-white text-[14px]" />
              </button>
            </div>
            <div className="w-full  mt-6 rounded-xl flex justify-center items-center">
              {imageUrl ? (
                <img
                  src={imageUrl ?? ""}
                  className="w-full h-full object-contain rounded-xl"
                  alt=""
                />
              ) : null}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MercahntLogs;
